import { Suspense } from 'react';
import { Canvas } from '@react-three/fiber';
import ParticleField from './ParticleField';

interface ParticleBackgroundProps {
  mousePosition?: { x: number; y: number };
}

const ParticleBackground: React.FC<ParticleBackgroundProps> = ({ mousePosition }) => {
  return (
    <div className="absolute inset-0 w-full h-full">
      <Suspense fallback={null}>
        <Canvas camera={{ position: [0, 0, 5], fov: 75 }}>
          <ambientLight intensity={0.2} />
          <pointLight position={[10, 10, 10]} intensity={0.5} color="#14F1E5" />
          <pointLight position={[-10, -10, -10]} intensity={0.4} color="#FF6B35" />
          <ParticleField mousePosition={mousePosition} />
        </Canvas>
      </Suspense>
    </div>
  );
};

export default ParticleBackground;

